export const ALLOWED_EVIDENCE_UPLOAD_FILE_TYPES = ['image/jpeg', 'image/png', 'video/mp4', 'video/quicktime'].join(
  ', '
);
